/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { User } from '../../../../../models/User';
import { ParamValueModel } from '../../../../../models/ParamValueModel';
import { ApigeeService } from '../../../../../services/apigee.service';
import { InsightBadge } from '../../../../shared/insight-badges/InsightBadge';
import { CountryCodeService } from '../../../../../services/country-code-service';
import { map, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { ScrollTriggerService } from 'app/services/scroll-trigger.service';
import {
  Breakpoint,
  MediaQueryService
} from '../../../../../services/media-query.service';
import { AppReviewBadgeComponent } from '../../../../shared/insight-badges/custom-badges/app-review-badge.component';
import { AppVpcBadgeComponent } from 'app/components/shared/insight-badges/custom-badges/app-vpc-badge.component';
import { LabelValue } from 'app/models/LabeLValue';

declare let jQuery;

@Component({
  selector: 'app-information',
  templateUrl: './app-information.html',
  styleUrls: ['./app-information.scss']
})
export class AppInformationComponent
  implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
  @Input() domain;
  @Input() region;
  @Input() device;
  @Input() data;
  @Input() month;
  @Input() os;
  @Input() appId;
  @Input() isFollowing: boolean;
  @Input() isAnonymous: boolean;
  @Input() numWatching = -1;
  @Input() processingFollow: boolean;
  @Input() selectedCountry: LabelValue;
  @Input() loading: boolean;
  @Input() isFreemium: boolean;
  @Output() anchorClick = new EventEmitter<string>();
  @Output() toAppDiscovery: EventEmitter<ParamValueModel> =
    new EventEmitter<ParamValueModel>();

  @Output() followButtonBreakpointReached: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() followButtonClick: EventEmitter<Event> = new EventEmitter<Event>();

  @ViewChild('followButton') followButton: ElementRef<HTMLElement>;

  hideReadMoreLink: boolean;
  hasDangerousPermissions: boolean;
  badges: Array<InsightBadge> = [];
  viewCount = -1;

  destroyToken: Subject<void>;
  desktop$: Observable<boolean>;
  tablet$: Observable<boolean>;
  mobile$: Observable<boolean>;

  constructor(
    public _userService: User,
    private _apigeeService: ApigeeService,
    private _scrollTrigger: ScrollTriggerService,
    private _countryCodeService: CountryCodeService,
    private mediaQueryService: MediaQueryService
  ) {}

  ngOnInit() {
    this.desktop$ = this.mediaQueryService.gt(Breakpoint.md);
    this.tablet$ = this.mediaQueryService.lt(Breakpoint.lg);
    this.mobile$ = this.mediaQueryService.lte(Breakpoint.md);
    this.destroyToken = new Subject();
  }

  ngAfterViewInit() {
    if (this.data.appOverview.screenshotUrls?.length <= 0) {
      jQuery('.screenshots-container').css('display', 'none');
      jQuery('.description-container').removeClass('invisible');
      jQuery('.app-information-container .fa-spinner').remove();
    }
    this.getNumViewing();

    this._scrollTrigger.callback$
      .pipe(
        takeUntil(this.destroyToken),
        map(() => {
          console.assert(
            this.followButton,
            'no follow button reference defined on the page'
          );
          const elBottom =
            this.followButton.nativeElement.getBoundingClientRect().bottom;

          return elBottom < 0;
        })
      )
      .subscribe(value => {
        this.followButtonBreakpointReached.emit(value);
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      const dangerousPermissions = (
        this.data['permissions']['all'] || []
      ).filter(permission => {
        return (
          permission &&
          permission.isDangerous &&
          permission.effects &&
          permission.effects.indexOf('Privacy') >= 0
        );
      });
      this.hasDangerousPermissions = dangerousPermissions.length > 0;

      setTimeout(() => {
        const scrollHeight = jQuery('.descriptionwrapper').prop('scrollHeight');
        if (scrollHeight > 210) {
          this.hideReadMoreLink = false;
        } else {
          this.hideReadMoreLink = true;
        }

        if (this.data.appOverview.description) {
          this.data.appOverview.description =
            this.data.appOverview.description.trim();
        }
      }, 100);

      const { coppaTargetChildrenRisk, isExistInAppStore, hasAdsTxt } =
        this.data.appOverview;
      const {
        ageGateDectected,
        allows13AndUnder,
        isReviewedManually,
        vpcDetected,
        passesLocation,
        ipTraffic
      } = this.data.coppaPermissions;
      const { country, countryCode, hasPrivacyLink } =
        this.data.publisherOverview;

      let coppaBadge, ageGateBadge, allows13AndUnderBadge;
      if (!coppaTargetChildrenRisk || coppaTargetChildrenRisk == 'N/A') {
        coppaBadge = {
          detectedText: 'N/A',
          icon: '/assets/images/unknown.svg',
          hidden: false
        };
      } else {
        const isCoppaTargetChildrenRiskLow = coppaTargetChildrenRisk == 'low';
        coppaBadge = {
          detectedText: isCoppaTargetChildrenRiskLow
            ? 'General Audience'
            : 'Child Directed',
          icon:
            coppaTargetChildrenRisk === 'high'
              ? '/assets/images/icon-child-audience.svg'
              : '/assets/images/icon-general-audience.svg',
          reverse: !isCoppaTargetChildrenRiskLow,
          hidden: !coppaTargetChildrenRisk
        };
      }

      if (ageGateDectected === true) {
        ageGateBadge = {
          badgeColor: 'green',
          detectedText: 'Detected',
          icon: '/assets/images/icon-age-gate-detected.svg'
        };
      } else if (ageGateDectected === false) {
        ageGateBadge = {
          badgeColor: 'red',
          detectedText: 'Not Detected',
          icon: '/assets/images/icon-age-gate-not-detected.svg'
        };
      } else {
        ageGateBadge = {
          hidden: true
        };
      }

      if (allows13AndUnder === true) {
        allows13AndUnderBadge = {
          badgeColor: 'green',
          detectedText: 'Access Permitted',
          icon: '/assets/images/icon-13-and-under-access-permitted.svg'
        };
      } else if (allows13AndUnder === false) {
        allows13AndUnderBadge = {
          badgeColor: 'red',
          detectedText: 'Access Denied',
          icon: '/assets/images/icon-13-and-under-access-denied.svg'
        };
      } else {
        allows13AndUnderBadge = {
          hidden: true
        };
      }

      this.badges = [
        {
          text: 'COPPA Audience',
          locked: this.isFreemium,
          detected: true,
          badgeColor: 'blue',
          anchorLink: '#app-coppa-permission-risk',
          ...coppaBadge
        },
        {
          component: AppReviewBadgeComponent,
          hidden: !isReviewedManually
        },
        {
          text: 'Age Gate',
          locked: this.isFreemium,
          anchorLink: '#app-coppa-permission-risk',
          ...ageGateBadge
        },
        {
          text: 'Under 13',
          locked: this.isFreemium,
          anchorLink: '#app-coppa-permission-risk',
          ...allows13AndUnderBadge
        },
        {
          component: AppVpcBadgeComponent,
          locked: this.isFreemium,
          hidden:
            coppaTargetChildrenRisk !== 'high' ||
            vpcDetected == undefined ||
            vpcDetected === 'N/A'
        },
        {
          text: 'Privacy Policy',
          locked: this.isFreemium,
          detected: hasPrivacyLink
        },
        {
          text: 'Programmatic Ads',
          locked: this.isFreemium,
          detected: this.data.advertisingCapabilities.hasAdServed
        },
        {
          text: this.os === 'android' ? 'In Play Store' : 'In App Store',
          locked: this.isFreemium,
          detected: isExistInAppStore
        },
        {
          text: 'App-ads.txt',
          locked: this.isFreemium,
          detected: hasAdsTxt
        },
        {
          text: 'Dangerous Permissions',
          locked: this.isFreemium,
          detected: true,
          reverse: true,
          hidden: !this.hasDangerousPermissions
        },
        {
          text: 'Transmits Location',
          locked: this.isFreemium,
          detected: passesLocation,
          reverse: true,
          anchorLink: '#app-coppa-permission-risk'
        },
        {
          text: 'Transmits Residential IP',
          locked: this.isFreemium,
          detected: ipTraffic,
          reverse: true,
          anchorLink: '#app-coppa-permission-risk'
        }
      ];

      if (country) {
        const shellState =
          this._countryCodeService.getShellStateByCountryName(country);
        const iconUrl = `/assets/images/icon-indicator-${shellState}.svg`;
        let rightIcon = `https://cdn.pixalate.com/icons/countries/flat/48/${countryCode}.png`;
        if (country === 'N/A') {
          rightIcon = null;
        }
        this.badges.push({
          badgeColor: shellState,
          text: 'Registered In',
          detectedText: country,
          detected: true,
          reverse: false,
          hidden: false,
          rightIcon,
          icon: iconUrl
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyToken.next();
    this.destroyToken.complete();
  }

  getNumViewing() {
    this.viewCount = -1;
    this._apigeeService
      .getNumViewingById(this.appId, 'apps')
      .then(response => {
        this.viewCount = response['views'];
      })
      .catch(() => {
        this.viewCount = 0;
      });
  }

  goToAppDiscovery(param: string, paramValue: string) {
    this.toAppDiscovery.emit({ param: param, paramValue: paramValue });
  }

  onAnchorClick(anchor: string) {
    this.anchorClick.emit(anchor);
  }
}
